import AccordionStrategy from "./accordion";
import AdBlock from "./ad-block";
import ArticleLoaderStrategy from "./article-loader";
import ArticleOfferStrategy from "./article-offer";
import ArticleSearchHeaderStrategy from "./article-search-header";
import BannerStrategy from "./banner";
import CategoryNavigationStrategy from "./category-navigation";
import DealerFeatureBlockStrategy from "./dealer-feature-block";
import DividerStrategy from "./divider";
import EventCountdown from "./event-countdown";
import FAQCollectionsStrategy from "./faq-collections";
import FeaturedCollectionsStrategy from "./featured-collections";
import FeaturedProductCollectionsStrategy from "./featured-product-collections";
import ImageBlockStrategy from "./image-block";
import ImageGridStrategy from "./image-grid";
import MofoPromiseBarStrategy from "./mofo-promise-bar";
import ProductCollectionStrategy from "./product-collection";
import PushNotificationBannerStrategy from "./push-notification-banner";
import QuoteblockBlockStrategy from "./quote-block";
import RecentArticlesStrategy from "./recent-articles";
import RichTextBlockStrategy from "./rich-text";
import SearchHeaderStrategy from "./search-header";
import SectionHeaderStrategy from "./section-header";
import SellBannerStrategy from "./sell-banner";
import SocialLinksStrategy from "./social-links";
import SplitBannerStrategy from "./split-banner";
import TextBlockStrategy from "./text-block";
import ThreeArticlesStrategy from "./three-articles";
import ThreeUpBannerGroupStrategy from "./three-up-banner-group";
import TwoUpBlockStrategy from "./two-up-block";
import UnknownStrategy from "./unknown-component";
import VideoBlockStrategy from "./video-block";
import offersCollection from "./offers-collection";
import DividerBrushStrategy from "./divider-brush";
import InfoBlocksStrategy from "./info-blocks";
import WhiskymofoSocialProofStrategy from "./whiskymofo-social-proof";
import ReferAFriend from "./refer-a-friend";

const componentStrategies = [
  BannerStrategy,
  CategoryNavigationStrategy,
  DealerFeatureBlockStrategy,
  DividerStrategy,
  DividerBrushStrategy,
  FeaturedCollectionsStrategy,
  FeaturedProductCollectionsStrategy,
  WhiskymofoSocialProofStrategy,
  ImageBlockStrategy,
  ImageGridStrategy,
  MofoPromiseBarStrategy,
  ProductCollectionStrategy,
  QuoteblockBlockStrategy,
  RecentArticlesStrategy,
  ArticleLoaderStrategy,
  ThreeArticlesStrategy,
  RichTextBlockStrategy,
  SearchHeaderStrategy,
  ArticleSearchHeaderStrategy,
  ArticleOfferStrategy,
  SectionHeaderStrategy,
  SocialLinksStrategy,
  SplitBannerStrategy,
  TextBlockStrategy,
  ThreeUpBannerGroupStrategy,
  TwoUpBlockStrategy,
  PushNotificationBannerStrategy,
  VideoBlockStrategy,
  AccordionStrategy,
  AdBlock,
  FAQCollectionsStrategy,
  EventCountdown,
  offersCollection,
  SellBannerStrategy,
  InfoBlocksStrategy,
  ReferAFriend,
  UnknownStrategy,
];
export const ContentBlock = (data) => {
  const strategy = componentStrategies.find((strategy) => strategy.test(data));
  return strategy.create(data);
};
